import React from 'react'
import Header from './components/Header'
import MobileIndex  from './pages/Index'

const App = () => {
  return (
    <>
      <Header />
      <MobileIndex />
    </>
    )
  }
  
  export default App